import React, { useState, useEffect } from "react";
import { EditBlock, EditBlockOption } from "../EditBlock";
import { Checkbox, Col, Row, Button } from "antd";
import style from "./EditDuoxuan.module.scss";
import { QuestionType } from "../../../../../service/service";
import {
    OptionIsRight,
    OptionType,
    TopicType
} from "../../../../../service/homework";
import { TransInput } from "../TransInput";
import { indexToChar } from "../../../../../utils/common";

interface EditDuoxuanProps {
    topic: TopicType;
    blockOption?: EditBlockOption;
    onChangeNow?: (topic: TopicType) => void;
    onChange: (topic: TopicType) => void;
}

export default function EditDuoxuan({
    topic,
    blockOption,
    onChange,
    onChangeNow
}: EditDuoxuanProps) {
    const [innerTopic, setInnerTopic] = useState(topic);

    useEffect(() => {
        onChangeNow && onChangeNow(innerTopic);
    }, [innerTopic]);

    const onInputChange = (index: number, value: string) => {
        const answers = [...innerTopic.answers];
        answers[index].content = value;
        setInnerTopic({ ...innerTopic, answers });
    };

    const onCheckChange = (index: number, isChecked: boolean) => {
        const answers = [...innerTopic.answers];
        answers[index].isRight = isChecked
            ? OptionIsRight.Right
            : OptionIsRight.Wrong;
        setInnerTopic({ ...innerTopic, answers });
    };

    const isChecked = (option: OptionType) => {
        return option.isRight === OptionIsRight.Right;
    };

    const onEditBlockChange = (topic: TopicType) => {
        const newTopic = { ...innerTopic };
        setInnerTopic({ ...newTopic, trunk: topic.trunk, score: topic.score });
        onChange && onChange(topic);
    };

    const deleteItem = (index: number) => {
        const newTopic = { ...innerTopic };
        newTopic.answers.splice(index, 1);
        setInnerTopic(newTopic);
    };

    const addItem = () => {
        const newTopic = { ...innerTopic };
        newTopic.answers.push({ content: "", isRight: OptionIsRight.Wrong });
        setInnerTopic(newTopic);
    };

    return (
        <EditBlock
            {...blockOption}
            type={QuestionType.DuoXuan}
            topic={innerTopic}
            onChange={onEditBlockChange}>
            <EditDuoxuanPure
                innerTopic={innerTopic}
                isChecked={isChecked}
                onCheckChange={onCheckChange}
                onInputChange={onInputChange}
                deleteItem={deleteItem}
                addItem={addItem}
            />
        </EditBlock>
    );
}

export interface EditDuoxuanPureProps {
    innerTopic: TopicType;
    isChecked: (option: OptionType) => boolean;
    onCheckChange: (index: number, isChecked: boolean) => void;
    onInputChange: (index: number, value: string) => void;
    deleteItem: (index: number) => void;
    addItem: () => void;
}

export function EditDuoxuanPure({
    addItem,
    deleteItem,
    innerTopic,
    isChecked,
    onCheckChange,
    onInputChange
}: EditDuoxuanPureProps) {
    return (
        <>
            <Col span={2} className={style.label}>
                选项：
            </Col>

            <Col span={20}>
                {innerTopic.answers.map((option, index) => (
                    <Row
                        gutter={10}
                        type="flex"
                        align="middle"
                        className={style.InputOption}
                        key={index}>
                        <Checkbox
                            className={style.OptionCheckbox}
                            checked={isChecked(option)}
                            onChange={e =>
                                onCheckChange(index, e.target.checked)
                            }>
                            {indexToChar(index)}
                        </Checkbox>
                        <Col span={22}>
                            <TransInput
                                index={index}
                                content={option.content}
                                onChange={onInputChange}
                            />
                        </Col>
                        <Col span={2}>
                            <Button
                                onClick={() => deleteItem(index)}
                                type="danger"
                                icon="delete"
                            />
                        </Col>
                    </Row>
                ))}
                <Button icon={"plus"} onClick={addItem}>
                    增加选项
                </Button>
            </Col>
        </>
    );
}
